module.exports = __webpack_public_path__ + "static/img/143_TO8_1846.fc73638.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/143_TO8_1846.jpg
// module id = 09Sh
// module chunks = 0